// src/redux/slices/timeSlotsSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { TimeSlotsRequest, TimeSlotsResponse } from '../../types/tableReservation';

interface TimeSlotsState {
  timeSlots: string[];
  day: string;
  reservationInterval: number;
  loading: boolean;
  error: string | null;
}

const initialState: TimeSlotsState = {
  timeSlots: [],
  day: '',
  reservationInterval: 60,
  loading: false,
  error: null,
};

export const timeSlotsSlice = createSlice({
  name: 'timeSlots',
  initialState,
  reducers: {
    fetchTimeSlotsRequest: (state, action: PayloadAction<TimeSlotsRequest>) => {
      state.loading = true;
      state.error = null;
    },
    fetchTimeSlotsSuccess: (state, action: PayloadAction<TimeSlotsResponse['data']>) => {
      state.timeSlots = action.payload.timeSlots;
      state.day = action.payload.day;
      state.reservationInterval = action.payload.reservationInterval;
      state.loading = false;
      state.error = null;
    },
    fetchTimeSlotsFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
      state.timeSlots = [];
    },
    clearTimeSlots: (state) => {
      state.timeSlots = [];
      state.day = '';
      state.error = null;
    },
  },
});

export const {
  fetchTimeSlotsRequest,
  fetchTimeSlotsSuccess,
  fetchTimeSlotsFailure,
  clearTimeSlots,
} = timeSlotsSlice.actions;

export default timeSlotsSlice.reducer;
